import Axios from 'axios';

// Matches wrench-www's Services/ContactData.ts NEXT_PUBLIC_API_URL fallback
// pattern — wrench-api's own dev port, for local dev without any
// docker-compose env var. Dockerfile.prod bakes this as a
// https://api.wrenchboard.com sentinel instead (see docker-entrypoint.sh),
// replaced with the real per-environment API host at container start.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:21000';

async function ContactData(payload) {
    const response = await Axios.post(`${API_BASE_URL}/website/contact`, payload);
    return response.data;
}

export default ContactData;
